/**
 * Get the current value of the provided CSS variable, from the document root node or provided element.
 *
 * @param cssVariable CSS variable of format `--${string}`
 * @param target The target element to obtain the styling from, defaults to the document root
 */
export function valueFromCssVar(cssVariable, target) {
    // During server-side rendering, `document` is not available
    if (typeof document === 'undefined') {
        return null;
    }
    const computedStyle = getComputedStyle(target !== null && target !== void 0 ? target : document.documentElement).getPropertyValue(cssVariable);
    return computedStyle.length > 0 ? computedStyle : null;
}
